import makeStyles from '@mui/styles/makeStyles';
import withStyles from '@mui/styles/withStyles';
import {Slider} from "@mui/material";

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
    },
    firstSceneContainer: {
        display: 'flex',
        flexDirection: "column",
        justifyContent: 'center',
        alignItems: 'center',
        textAlign: 'center',
    },
    scoreSummaryRow: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center'
    },
    redBox: {
        backgroundColor: "red",
        height: 30,
        width: 40,
        marginLeft: 5,
        marginRight: 5,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        fontSize: 14,
        fontWeight: "bold",
        border: "solid black 1px",
        borderRadius: 20,
        boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px"
    },
    blueBox: {
        backgroundColor: "blue",
        height: 30,
        width: 40,
        marginLeft: 5,
        marginRight: 5,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        fontSize: 14,
        fontWeight: "bold",
        border: "solid black 1px",
        borderRadius: 20,
        boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px"
    },
    athletePositionBoxContainer: {
        display: 'flex',
        flexDirection: "row",
        alignItems: 'center'
    }
}));

const VideoCutSlider = withStyles({
    root: {
        height: 2
    },
    thumb: {
        height: 20,
        width: 1
    },
    active: {},
    valueLabel: {
        backgroundColor: "transparent",
        color: "transparent"
    },
    track: {
        height: 0,
    },
    rail: {
        height: 2,
        opacity: 0.5,
    },
    mark: {
        height: 8,
        width: 1,
    },
    markActive: {
        opacity: 1,
        backgroundColor: 'currentColor',
    },
})(Slider);

export {useStyles, VideoCutSlider};